import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';

export enum MessagesEvents {
  newUnreadMessageChannelListClick = 'New Unread Message Channel List Click',
  pinnedUnreadMessageChannelListClick = 'Pinned Unread Message Channel List Click',

  patientChartMessageChannelPinMessage = 'Patient Chart Message Channel Pin Message',
  patientChartMessageChannelUnpinMessage = 'Patient Chart Message Channel Unpin Message',

  patientChartMessageChannelExpandThread = 'Patient Chart Message Channel Expand Thread',

  newUnreadMessageChannelExpandList = 'New Unread Message Channel Expand List',
  newUnreadMessageChannelCollapseList = 'New Unread Message Channel Collapse List',
  pinnedUnreadMessageChannelExpandList = 'Pinned Unread Message Channel Expand List',
  pinnedUnreadMessageChannelCollapseList = 'Pinned Unread Message Channel Collapse List',

  maudLeftNavBarMessagesTab = 'Maud Left Nav Bar Messages Tab',
  patientChartMessagesTab = 'Patient Chart Messages Tab',

  patientChartMessagesCreateNewMessage = 'Patient Chart Messages Create New Message',
}

export interface MessagesEventsProps extends Record<string, unknown> {
  patientId?: string;
  channelUrl?: string;
  channelType?: string;
  messageId?: string;
  messageType?: 'MESG' | 'FILE';
  source?:
    | AnalyticsSourceValues.MESSAGES_MENU
    | AnalyticsSourceValues.PATIENT_MESSAGES_TAB
    | AnalyticsSourceValues.MAUD_LEFT_NAV
    | AnalyticsSourceValues.PATIENT_CHART_NAVIGATION;
}
